import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SeRegistrationUiRegistrationCardModule } from '../lib/se-registration-ui-registration-card.module'
import { RegistrationCardDocsComponent } from './registration-card-docs/registration-card-docs.component'
import { RegistrationCardExampleComponent } from './registration-card-docs/registration-card-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SeRegistrationUiRegistrationCardModule
  ],
  declarations: [
    RegistrationCardDocsComponent,
    RegistrationCardExampleComponent
  ],
  exports: [
    RegistrationCardDocsComponent
  ]
})
export class SeRegistrationUiRegistrationCardDocsModule {}
